/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {shopSearchProductFilters} from '../api'

export const useMutationShopSearchProductFilters = createReactQueryMutationHook('shopSearchProductFilters', shopSearchProductFilters)
